(ns frontend.view.nev.kyc.process.screening-profiles.sub
  (:require
   [frontend.view.nev.kyc.process.screening-profiles.model :as model]
   [re-frame.core :as rf]))

;; The id of the KYC profile that holds the KYC process, or nil while it loads
;; or when no profile holds the process.
(rf/reg-sub
 ::profile-id
 (fn [db [_ kyc-process-id]]
   (model/profile-id (get-in db (model/profile-id-path kyc-process-id)))))

;; A process without a KYC profile has no scope to wait for. The table shows the
;; error and does not wait for ever.
(rf/reg-sub
 ::load-status
 (fn [db [_ kyc-process-id]]
   (model/process-load-status db kyc-process-id)))

(rf/reg-sub
 ::profiles
 (fn [db [_ kyc-process-id]]
   (model/process-profile-list db kyc-process-id)))
